import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const pasteElement = (refElementId, position = 'afterend', options = {}) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.PASTE_ELEMENT,
    payload: {
      refElementId,
      position,
      options: { ...DEFAULT_OPTIONS, ...options },
    },
  });

export default pasteElement;
